import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "aos/dist/aos.css";
import { tg_title_animation } from "./lib/gsap/tg_title_animation";
import HomeTwo from "./pages/Home/HomeTwo";
import { useParticles } from "./lib/hooks/useParticles";
import { useParallax } from "./lib/hooks/useParallax";
import { useHasAnimation } from "./lib/hooks/useHasAnimation";
import AboutPageFour from "./pages/About/AboutPageFour";
import ServicesPage from "./pages/Services/ServicesPage";
import ServicesDetailsPageFour from "./pages/ServicesDetails/ServicesDetailsPageFour";
import ErrorPage from "./pages/ErrorPage/ErrorPage";
import BlogPage from "./pages/BlogPages/BlogPage";
import BlogDetailsPage from "./pages/BlogPages/BlogDetailsPage";
import ContactPage from "./pages/Contact/ContactPage";
import { useWow } from "./lib/hooks/useWow";
import { useAos } from "./lib/hooks/useAos";
import { useJarallax } from "./lib/hooks/useJarallax";
import { LocaleLayout } from "./i18n/LocaleLayout";
import { getPreferredLocale, withLocale } from "./i18n/config";

const LegacyRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const locale = getPreferredLocale();
  return (
    <Navigate to={`${withLocale(pathname, locale)}${search}${hash}`} replace />
  );
};

const RootRedirect = () => {
  const locale = getPreferredLocale();
  return <Navigate to={`/${locale}`} replace />;
};

function App() {
  const { i18n } = useTranslation();
  useWow();
  useAos();
  useJarallax();
  useParallax();
  useParticles();
  useHasAnimation();

  // Re-run GSAP title splits when route or language changes so text is not stuck in the previous locale
  useEffect(() => {
    const id = window.setTimeout(() => {
      tg_title_animation();
    }, 50);
    return () => window.clearTimeout(id);
  }, [i18n.language]);

  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const id = window.setTimeout(() => {
      tg_title_animation();
    }, 50);
    return () => window.clearTimeout(id);
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />

      <Route path="/:locale" element={<LocaleLayout />}>
        <Route index element={<HomeTwo />} />
        <Route path="about" element={<AboutPageFour />} />
        <Route path="services" element={<ServicesPage />} />
        <Route path="services-details-4" element={<ServicesDetailsPageFour />} />
        <Route path="blog" element={<BlogPage />} />
        <Route path="blog-details" element={<BlogDetailsPage />} />
        <Route path="contact" element={<ContactPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Route>

      <Route path="/about" element={<LegacyRedirect />} />
      <Route path="/services" element={<LegacyRedirect />} />
      <Route path="/services-details-4" element={<LegacyRedirect />} />
      <Route path="/blog" element={<LegacyRedirect />} />
      <Route path="/blog-details" element={<LegacyRedirect />} />
      <Route path="/contact" element={<LegacyRedirect />} />
    </Routes>
  );
}

export default App;
